const styles = (theme) => ({
    tabRoot: {
        background: 'white',
        borderBottom: '1px solid #ededed',
        borderRadius: '5px 5px 0 0'
    }
});

export default styles;
